const ServicesSection = () => {
  const services = [
    {
      icon: 'ri-gamepad-line',
      title: '遊戲產品代理',
      description: '精選全球優質遊戲產品，提供專業的代理服務，包括遊戲引進、本地化、發行與營運支援，協助遊戲開發商快速進入台灣市場。',
      features: ['遊戲引進與評估', '本地化翻譯', '發行與上架', '營運支援']
    },
    {
      icon: 'ri-code-box-line',
      title: '遊戲研發服務',
      description: '提供完整的遊戲研發解決方案，從概念設計、技術開發到測試優化，我們的專業團隊協助您打造高品質的遊戲產品。',
      features: ['遊戲設計諮詢', '技術開發支援', '品質測試', '性能優化']
    },
    {
      icon: 'ri-megaphone-line',
      title: '市場推廣',
      description: '運用數據驅動的行銷策略，透過多元化的推廣渠道，精準觸及目標玩家，提升遊戲知名度與下載量，創造最大化的市場效益。',
      features: ['行銷策略規劃', '社群媒體經營', '廣告投放優化', 'KOL 合作']
    },
    {
      icon: 'ri-team-line',
      title: '玩家社群經營',
      description: '建立活躍的玩家社群，提供優質的客戶服務，透過社群互動增強玩家黏著度，打造忠誠的玩家基礎，提升遊戲長期價值。',
      features: ['社群平台建立', '玩家活動策劃', '客服支援', '意見回饋管理']
    },
    {
      icon: 'ri-bar-chart-box-line',
      title: '數據分析與優化',
      description: '運用先進的數據分析工具，深入了解玩家行為與市場趨勢，提供專業的數據洞察，協助優化遊戲內容與營運策略。',
      features: ['玩家行為分析', '營收數據追蹤', '市場趨勢研究', '優化建議']
    },
    {
      icon: 'ri-trophy-line',
      title: '電競賽事支援',
      description: '提供專業的電競賽事規劃與執行服務，從賽事策劃、選手招募到直播製作，打造精彩的電競賽事，提升遊戲品牌影響力。',
      features: ['賽事策劃', '選手管理', '直播製作', '品牌曝光']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題 */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            我們的<span className="text-orange-500">專業服務</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            提供全方位的<strong>遊戲產業解決方案</strong>，從<strong>產品代理</strong>、<strong>研發支援</strong>到<strong>市場推廣</strong>，協助您在競爭激烈的遊戲市場中脫穎而出
          </p>
        </div>

        {/* 服務卡片 */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-orange-200 group"
            >
              {/* 圖標 */}
              <div className="w-16 h-16 bg-gradient-to-br from-orange-400 to-orange-600 rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>

              {/* 標題 */}
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>

              {/* 描述 */}
              <p className="text-gray-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              {/* 特色列表 */}
              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center text-gray-700">
                    <i className="ri-check-line text-orange-500 mr-2"></i>
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* 了解更多 */}
              <div className="mt-6 pt-6 border-t border-gray-100">
                <a 
                  href="#contact"
                  className="text-orange-500 font-semibold hover:text-orange-600 transition-colors inline-flex items-center"
                >
                  了解更多
                  <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* CTA 區域 */}
        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl p-12 text-white">
            <h3 className="text-3xl font-bold mb-4">準備開始您的遊戲項目？</h3>
            <p className="text-xl mb-8 text-orange-100">
              讓我們的專業團隊協助您實現遊戲夢想，打造成功的遊戲產品
            </p>
            <a 
              href="#contact"
              className="inline-flex items-center bg-white text-orange-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              立即聯繫我們
              <i className="ri-arrow-right-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
